import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const NoticeGuard = ({ children }) => {
  const navigate = useNavigate();
  const { user } = useAuth();

  useEffect(() => {
    if (user) {
      const noticeAcknowledged = localStorage.getItem('noticeAcknowledged') === 'true';
      
      // If notice hasn't been acknowledged, redirect to notice page
      if (!noticeAcknowledged) {
        navigate('/notice', { replace: true });
      }
    }
  }, [user, navigate]);

  return children;
};

export default NoticeGuard;
